import { forwardRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { TitleContentComponent } from 'ngx-zcs-components';

import { CreateBlockComponent } from './create-block.component';
import { ConfigurationSectionComponent } from '../configuration-section/configuration-section.component';
import { ConnextDevicesSectionComponent } from '../connext-devices-section/connext-devices-section.component';
import { CreateFirebaseBlock } from '../create-firebase/create-firebase.block';
import { MonitoringSectionComponent } from '../monitoring-section/monitoring-section.component';
import { UsersSectionComponent } from '../users-section/users-section.component';
import { VirtualDevicesSectionComponent } from '../virtual-devices-section/virtual-devices-section.component';
import { CreateAwsComponent } from '../create-aws/create-aws.component';
import { ComponentsModule } from '../components/components.module';
import { ChoiceWithImgComponent } from '../components/choice-with-img/choice-with-img.component';
import { AzzurroHubDevicesSectionComponent } from '../azzurro-hub-devices-section/azzurro-hub-devices-section.component';

@NgModule({
  declarations: [
    CreateFirebaseBlock,
    CreateBlockComponent,
    CreateAwsComponent,
  ],
  imports: [
    AzzurroHubDevicesSectionComponent,
    ChoiceWithImgComponent,
    CommonModule,
    ComponentsModule,
    forwardRef(() => ConfigurationSectionComponent),
    forwardRef(() => ConnextDevicesSectionComponent),
    forwardRef(() => MonitoringSectionComponent),
    forwardRef(() => TitleContentComponent),
    forwardRef(() => UsersSectionComponent),
    forwardRef(() => VirtualDevicesSectionComponent),
    MatButtonModule,
    MatIconModule,
    MatStepperModule,
    TranslateModule,
  ],
  exports: [
    CreateBlockComponent,
  ],
})
export class CreateBlockModule {}
